import {Submissions, getFormMessages, isWixFormsSupported} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {FormStep, RSVP_STEPS} from '../../../constants/constants'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {isWixFormsEnabled} from '../../../selectors/events-settings'
import {hasAgreedWithPolicies, hasPolicies as hasPoliciesSelector} from '../../../selectors/policies'
import {
  getCurrentStep,
  getFormSubmissions,
  getRsvpDetails,
  isStepCompleted,
  isStepVisible,
} from '../../../selectors/rsvp'
import {BuyerDetails} from '../../buyer-details'
import {Policies} from '../../policies'
import {RsvpFormContainerProps} from './interfaces'

export const RsvpFormContainer = ({children}: RsvpFormContainerProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const {submitRsvpStep, submitRsvpStepOld, editRsvpStep} = useAppActions()

  const event = useAppSelector(getEvent)
  const currentStep = useAppSelector(getCurrentStep)
  const rsvpDetails = useAppSelector(getRsvpDetails)
  const submissions = useAppSelector(getFormSubmissions)
  const agreedWithPolicies = useAppSelector(hasAgreedWithPolicies)
  const hasPolicies = useAppSelector(hasPoliciesSelector)
  const wixFormsEnabled = useAppSelector(state => isWixFormsEnabled(state, experiments))

  const useWixForms = isWixFormsSupported(event) && wixFormsEnabled

  const {
    rsvp: {positiveMessages},
  } = getFormMessages(event)

  const getSteps = () =>
    RSVP_STEPS.filter(step => isStepVisible({step, hasPolicies})).map(step => ({
      key: step,
      title: step === FormStep.BuyerDetails ? positiveMessages.title : t(`mobile.checkout.step.${step}`),
      completed: isStepCompleted({
        step,
        rsvpDetails,
        submissions,
        agreedWithPolicies,
      }),
      renderStep: renderStep(step),
      onEdit: editRsvpStep,
    }))

  const renderStep = (step: FormStep) => {
    const props = {
      onSubmit: useWixForms ? (data?: Submissions) => submitRsvpStep(data) : (data: any) => submitRsvpStepOld(data),
      t,
    }

    switch (step) {
      case FormStep.BuyerDetails:
        return (editing: boolean) => <BuyerDetails editing={editing} {...props} />
      case FormStep.Policies:
        return (editing: boolean) => <Policies editing={editing} {...props} />
      default:
        return () => null
    }
  }

  return children(getSteps(), currentStep)
}
